var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Toptitle"},[_c('h3',[_c('i',{staticClass:"fa fa-tags"}),_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("../../assets/static/images/footer-split.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }